
import './App.css';
import { Link } from 'react-router-dom';
import routes from './routeNames';
import { useUi } from './context/UiContext';
import { t } from './i18n';
import Seo from './components/Seo';
import HexBackground from './components/HexBackground';

function App() {
  const { lang } = useUi();
  const headlines = [
    'Build the future with expert technologists',
    'Ship faster with AI-ready platforms',
    'From R&D to resilient production systems',
    'Design, prototype, and scale modern products',
    'Applied AI and engineering that delivers',
    'Engineer what’s next, not just what’s needed',
    'Make intelligent systems people can trust',
    'Turn research into reliable products',
    'Modernize without compromise',
    'Deliver velocity with veracity',
    'Less slideware, more software',
    'From whiteboard to world‑scale',
    'Data in motion. Ideas in production.',
    'Ship confidently into the unknown',
    'Resilient platforms for ambitious ideas',
    'Small teams, outsized outcomes',
    'Applied science. Practical elegance.',
    'Code that compounds value over time',
    'The shortest path from concept to impact',
    'Architecture for the age of AI',
    'Prototype boldly. Deploy safely.',
    'Make complexity feel simple',
    'Operational excellence by design',
    'Human‑centered AI, production‑grade systems',
    'Precision engineering for real problems',
    'Crafters of scalable, observable software',
    'Build right. Then build fast.',
    'Where product sense meets deep tech',
    'Systems that endure, interfaces that delight',
    'Innovation with guardrails and gravity'
  ];
  const headline = headlines[Math.floor(Math.random() * headlines.length)];
  return (
    <section className="hero" style={{ position: 'relative' }}>
      <HexBackground fixed={true} base={18} gap={18} rotateMax={33} delayMs={450} noise={0.3} noiseSpeed={0.0006} />
      <Seo title={t(lang, 'home.title')} description={t(lang, 'home.subtitle')} />
      <div className="hero-card">
        <h1 className="hero-title">{headline}</h1>
        <p className="hero-subtitle">{t(lang, 'home.subtitle')}</p>
        <div className="cta-row">
          <Link className="btn primary" to={routes.projects}>{t(lang, 'home.ctaProjects')}</Link>
          <Link className="btn" to={routes.who}>{t(lang, 'home.ctaWho')}</Link>
        </div>
      </div>
    </section>
  );
}

export default App;
